module.exports = __webpack_public_path__ + "static/image3-0a7226cb6d9cb8ed611d038885445c08.png";